import { routePolicy } from './policy/routePolicy';
import type { Language } from '@/i18n/types';
import { isValidUuid } from '../utils/uuid';

export interface PageSeo {
  title: string;
  description: string;
  h1: string;
}

export type RouteSeo = Record<Language, PageSeo>;

export const ROUTE_SEO: Readonly<Record<string, RouteSeo>> = {
  '/': {
    ru: {
      title: 'Кейсы CS2 онлайн — открытие кейсов и скины | SHOT',
      description:
        'Открывайте кейсы CS2 на SHOT, участвуйте в кейс-баттлах, используйте Upgrade и контракты. Изучайте содержимое кейсов и получайте скины Counter-Strike 2.',
      h1: 'Кейсы CS2, кейс-баттлы и скины на SHOT',
    },
    en: {
      title: 'CS2 Case Opening & Skins Online | SHOT',
      description:
        'Explore CS2 case opening on SHOT. Open virtual Counter-Strike 2 cases, join case battles, upgrade skins and discover the contents of each case.',
      h1: 'Open CS2 Cases, Play Case Battles & Upgrade Skins',
    },
    uz: {
      title: 'CS2 Keys Ochish va Skinlar | SHOT',
      description:
        'SHOTʼda CS2 keyslarini oching, skinlar oling va case battle rejimida qatnashing. Keyslar, kontraktlar, upgrade va boshqa imkoniyatlar bilan tanishing.',
      h1: 'CS2 keyslarini ochish, skinlar va case battle',
    },
    fa: {
      title: 'باز کردن کیس CS2 و اسکین‌های کانتر | SHOT',
      description:
        'در SHOT کیس‌های مجازی CS2 را بررسی و باز کنید. محتوای کیس‌ها، نبرد کیس، ارتقای اسکین و قوانین دریافت آیتم‌ها را بشناسید.',
      h1: 'باز کردن کیس CS2، نبرد کیس و ارتقای اسکین',
    },
    pt: {
      title: 'Abrir Caixas de CS2 Online e Skins | SHOT',
      description:
        'Abra caixas de CS2 no SHOT e descubra skins de Counter-Strike 2. Explore batalhas de caixas, contratos, upgrades e diferentes coleções de skins.',
      h1: 'Abertura de caixas CS2, skins e batalhas',
    },
    tr: {
      title: 'CS2 Kasa Açma ve Skinler | SHOT',
      description:
        "SHOT'ta CS2 kasalarını keşfedin ve açın. Kasa savaşları, skin yükseltme ve kontrat modlarını inceleyin. Kasaların içeriklerini ve oyun kurallarını öğrenin.",
      h1: 'CS2 kasa açma, kasa savaşları ve skinler',
    },
    uk: {
      title: 'Відкриття кейсів CS2 і скіни онлайн | SHOT',
      description:
        'Відкривайте кейси CS2 на SHOT, переглядайте їхній вміст, беріть участь у кейс-батлах, покращуйте скіни та дізнавайтеся правила кожного режиму.',
      h1: 'Відкриття кейсів CS2, кейс-батли та скіни',
    },
    de: {
      title: 'CS2 Kisten öffnen und Skins entdecken | SHOT',
      description:
        'Öffne CS2 Kisten auf SHOT, entdecke mögliche Skins und nutze Case Battles, Upgrader und Contracts. Prüfe Inhalte, Chancen und Regeln vorab.',
      h1: 'CS2 Kisten öffnen und Skins entdecken',
    },
    es: {
      title: 'Abrir cajas de CS2 y conseguir skins | SHOT',
      description:
        'Abre cajas de CS2 en SHOT, descubre skins, participa en Case Battles y mejora tus objetos. Consulta el contenido, las probabilidades y las reglas.',
      h1: 'Abrir cajas de CS2 y conseguir skins',
    },
    pl: {
      title: 'Otwieranie skrzynek CS2 — skiny online | SHOT',
      description:
        'Otwieraj skrzynki CS2 na SHOT, odkrywaj skiny, graj w Case Battles i korzystaj z Upgradera oraz Contracts. Sprawdź zawartość, szanse i zasady.',
      h1: 'Otwieranie skrzynek CS2',
    },
  },
  '/cases': {
    ru: {
      title: 'Открытие кейсов CS2 — каталог кейсов | SHOT',
      description:
        'Выбирайте кейсы CS2 на SHOT: смотрите содержимое, стоимость открытия и доступные коллекции. Сравните кейсы и откройте подходящий.',
      h1: 'Каталог кейсов CS2',
    },
    en: {
      title: 'CS2 Cases — Browse Case Contents | SHOT',
      description:
        'Explore the CS2 case catalog on SHOT. Check the items inside each case, review opening costs and compare available case collections.',
      h1: 'Explore CS2 cases',
    },
    uz: {
      title: 'CS2 Keyslar — Keyslar Katalogi | SHOT',
      description:
        'SHOTʼda CS2 keyslarini koʻring: har bir keysning tarkibi va ochish narxini tekshiring, turli keyslarni solishtiring va oʻzingizga mosini tanlang.',
      h1: 'CS2 keyslari katalogi',
    },
    fa: {
      title: 'کیس‌های CS2 — فهرست و محتویات کیس‌ها | SHOT',
      description:
        'فهرست کیس‌های CS2 را در SHOT ببینید. آیتم‌های هر کیس، هزینه باز کردن و گزینه‌های موجود را بررسی و با یکدیگر مقایسه کنید.',
      h1: 'فهرست کیس‌های CS2',
    },
    pt: {
      title: 'Caixas de CS2 — Catálogo de Caixas | SHOT',
      description:
        'Explore o catálogo de caixas de CS2 no SHOT. Confira os itens disponíveis, veja o custo de abertura e escolha a caixa que deseja conhecer.',
      h1: 'Catálogo de caixas de CS2',
    },
    tr: {
      title: 'CS2 Kasaları — Kasa Kataloğu | SHOT',
      description:
        "SHOT'taki CS2 kasalarını keşfedin. Kasa içeriklerini ve açılış bedellerini inceleyin, farklı seçenekleri karşılaştırın ve kasaları görüntüleyin.",
      h1: 'CS2 kasa kataloğu',
    },
    uk: {
      title: 'Кейси CS2 — каталог і вміст кейсів | SHOT',
      description:
        'Переглядайте каталог кейсів CS2 на SHOT: порівнюйте доступні колекції, вміст і актуальну вартість відкриття та обирайте потрібний кейс.',
      h1: 'Каталог кейсів CS2',
    },
    de: {
      title: 'CS2 Kisten im Überblick — Inhalte ansehen | SHOT',
      description:
        'Entdecke alle verfügbaren CS2 Kisten auf SHOT. Vergleiche Inhalte und aktuelle Öffnungspreise und wähle das passende Case aus.',
      h1: 'Alle CS2 Kisten im Überblick',
    },
    es: {
      title: 'Cajas de CS2 — Contenido y catálogo | SHOT',
      description:
        'Explora las cajas de CS2 disponibles en SHOT. Compara su contenido y el coste actual de apertura y elige la caja que quieres conocer.',
      h1: 'Cajas de CS2',
    },
    pl: {
      title: 'Skrzynki CS2 — Zawartość i katalog | SHOT',
      description:
        'Przeglądaj skrzynki CS2 dostępne na SHOT. Porównaj zawartość i aktualny koszt otwarcia, a następnie wybierz skrzynkę, którą chcesz sprawdzić.',
      h1: 'Skrzynki CS2',
    },
  },
  '/case-battles': {
    ru: {
      title: 'Кейс-баттлы CS2 — битвы кейсов | SHOT',
      description:
        'Участвуйте в кейс-баттлах CS2 на SHOT: изучайте открытые игры, создавайте баттлы и следите за результатами. Ознакомьтесь с правилами участия.',
      h1: 'Кейс-баттлы CS2',
    },
    en: {
      title: 'CS2 Case Battles — Join & Create Battles | SHOT',
      description:
        'Explore CS2 case battles on SHOT. Browse open battles, create a match and follow results. Read the participation rules before joining.',
      h1: 'CS2 case battles',
    },
    uz: {
      title: 'CS2 Keys Janglari — Case Battles | SHOT',
      description:
        'SHOTʼda CS2 keys janglarini koʻring: ochiq janglarni tanlang, yangi jang yarating va natijalarni kuzating. Ishtirok etish qoidalarini oʻqing.',
      h1: 'CS2 keys janglari',
    },
    fa: {
      title: 'نبرد کیس‌های CS2 — Case Battles | SHOT',
      description:
        'در نبرد کیس‌های CS2 در SHOT، بازی‌های باز را ببینید، نبرد جدید بسازید و نتیجه‌ها را دنبال کنید. پیش از شرکت، قوانین را مطالعه کنید.',
      h1: 'نبرد کیس‌های CS2',
    },
    pt: {
      title: 'Batalhas de Caixas CS2 — Case Battles | SHOT',
      description:
        'Participe de batalhas de caixas CS2 no SHOT. Confira partidas abertas, crie uma batalha e acompanhe os resultados. Veja as regras antes de entrar.',
      h1: 'Batalhas de caixas CS2',
    },
    tr: {
      title: 'CS2 Kasa Savaşları — Case Battles | SHOT',
      description:
        "SHOT'ta CS2 kasa savaşlarını keşfedin. Açık karşılaşmaları görüntüleyin, yeni savaş başlatın ve sonuçları takip edin. Katılım kurallarını inceleyin.",
      h1: 'CS2 kasa savaşları',
    },
    uk: {
      title: 'Кейс-батли CS2 — битви кейсів | SHOT',
      description:
        'Беріть участь у кейс-батлах CS2 на SHOT: переглядайте відкриті битви кейсів, створюйте нові ігри та стежте за результатами.',
      h1: 'Кейс-батли CS2',
    },
    de: {
      title: 'CS2 Case Battles — Battles erstellen & spielen | SHOT',
      description:
        'Entdecke CS2 Case Battles auf SHOT. Sieh dir offene Spiele an, erstelle ein Battle und verfolge Ergebnisse. Prüfe Format und Regeln vor dem Beitritt.',
      h1: 'CS2 Case Battles',
    },
    es: {
      title: 'Case Battles de CS2 — Batallas de cajas | SHOT',
      description:
        'Participa en Case Battles de CS2 en SHOT: consulta partidas abiertas, crea una batalla de cajas y sigue los resultados. Revisa las reglas antes de entrar.',
      h1: 'Case Battles de CS2',
    },
    pl: {
      title: 'Bitwy skrzynek CS2 — Case Battles | SHOT',
      description:
        'Dołącz do bitew skrzynek CS2 na SHOT: przeglądaj otwarte gry, twórz Case Battles i śledź wyniki. Sprawdź format i zasady przed dołączeniem.',
      h1: 'Bitwy skrzynek CS2',
    },
  },
  '/upgrade': {
    ru: {
      title: 'Апгрейд скинов CS2 — Upgrade на SHOT',
      description:
        'Апгрейд скинов CS2 на SHOT: выберите предмет из инвентаря и попробуйте получить более ценный. Изучите условия и риски перед попыткой.',
      h1: 'Апгрейд скинов CS2',
    },
    en: {
      title: 'CS2 Skin Upgrade — Upgrade Skins | SHOT',
      description:
        'Explore CS2 skin upgrades on SHOT. Choose an item from your inventory and try for a higher-value skin. Review the rules and risks before upgrading.',
      h1: 'CS2 skin upgrade',
    },
    uz: {
      title: 'CS2 Skin Upgrade — Skinlarni Yaxshilash | SHOT',
      description:
        'SHOTʼda CS2 skin upgrade rejimini sinab koʻring: inventardan buyumni tanlang va qimmatroq skin olishga urinib koʻring. Shartlarni oldindan oʻqing.',
      h1: 'CS2 skin upgrade',
    },
    fa: {
      title: 'ارتقای اسکین CS2 — حالت Upgrade در SHOT',
      description:
        'در بخش ارتقای اسکین CS2 در SHOT، آیتمی از موجودی خود انتخاب کنید و برای دریافت اسکین باارزش‌تر تلاش کنید. پیش از شروع، قوانین و ریسک‌ها را بخوانید.',
      h1: 'ارتقای اسکین CS2',
    },
    pt: {
      title: 'Upgrade de Skins CS2 — Melhorar Itens | SHOT',
      description:
        'Conheça o upgrade de skins CS2 no SHOT. Escolha um item do inventário e tente obter um de maior valor. Consulte regras e riscos antes de jogar.',
      h1: 'Upgrade de skins CS2',
    },
    tr: {
      title: 'CS2 Skin Yükseltme — Upgrade | SHOT',
      description:
        "SHOT'ta CS2 skin yükseltme modunu keşfedin. Envanterinizden bir öğe seçin ve daha değerli bir skin elde etmeyi deneyin. Kuralları inceleyin.",
      h1: 'CS2 skin yükseltme',
    },
    uk: {
      title: 'Апгрейд скінів CS2 — Upgrader | SHOT',
      description:
        'Спробуйте апгрейд скінів CS2 на SHOT: оберіть предмет з інвентарю, цільовий скін і перевірте показаний шанс перед спробою покращення.',
      h1: 'Апгрейд скінів CS2',
    },
    de: {
      title: 'CS2 Skin Upgrader — Skins upgraden | SHOT',
      description:
        'Nutze den CS2 Skin Upgrader auf SHOT: Wähle einen Gegenstand und einen Ziel-Skin und prüfe die angezeigte Chance, bevor du das Upgrade startest.',
      h1: 'CS2 Skin Upgrader',
    },
    es: {
      title: 'Mejorar skins de CS2 — Skin Upgrader | SHOT',
      description:
        'Mejora skins de CS2 en SHOT: elige un objeto de tu inventario, selecciona la skin objetivo y consulta la probabilidad mostrada antes del upgrade.',
      h1: 'Mejorar skins de CS2',
    },
    pl: {
      title: 'Ulepszanie skinów CS2 — Skin Upgrader | SHOT',
      description:
        'Ulepszaj skiny CS2 na SHOT: wybierz przedmiot z ekwipunku i docelowy skin, a następnie sprawdź wyświetlaną szansę przed rozpoczęciem upgrade’u.',
      h1: 'Ulepszanie skinów CS2',
    },
  },
  '/contracts': {
    ru: {
      title: 'Контракты CS2 — обмен скинов | SHOT',
      description:
        'Контракты на SHOT: объединяйте несколько предметов из инвентаря в попытке получить один новый. Изучайте условия обмена и возможные результаты.',
      h1: 'Контракты скинов CS2',
    },
    en: {
      title: 'CS2 Skin Contracts — Combine Items | SHOT',
      description:
        'Explore CS2 skin contracts on SHOT. Combine multiple inventory items for a chance to receive one new item. Check contract rules and possible outcomes.',
      h1: 'CS2 skin contracts',
    },
    uz: {
      title: 'CS2 Skin Kontraktlari — Buyumlarni Birlashtirish | SHOT',
      description:
        'SHOTʼda CS2 skin kontraktlari bilan tanishing: inventardagi bir nechta buyumni birlashtirib, bitta yangi buyum olishga urinib koʻring.',
      h1: 'CS2 skin kontraktlari',
    },
    fa: {
      title: 'قرارداد اسکین CS2 — ترکیب آیتم‌ها | SHOT',
      description:
        'در قراردادهای اسکین CS2 در SHOT، چند آیتم از موجودی خود را برای دریافت یک آیتم جدید ترکیب کنید. قوانین و نتایج احتمالی را بررسی کنید.',
      h1: 'قراردادهای اسکین CS2',
    },
    pt: {
      title: 'Contratos de Skins CS2 — Troca de Itens | SHOT',
      description:
        'Conheça os contratos de skins CS2 no SHOT: combine vários itens do inventário para tentar receber um novo. Confira as regras e os possíveis resultados.',
      h1: 'Contratos de skins CS2',
    },
    tr: {
      title: 'CS2 Skin Kontratları — Eşya Birleştirme | SHOT',
      description:
        "SHOT'ta CS2 skin kontratlarını inceleyin. Envanterinizdeki birden fazla öğeyi birleştirerek yeni bir öğe elde etmeyi deneyin. Kuralları okuyun.",
      h1: 'CS2 skin kontratları',
    },
    uk: {
      title: 'Контракти CS2 — об’єднання скінів | SHOT',
      description:
        'Використовуйте контракти CS2 на SHOT: об’єднуйте кілька предметів з інвентарю, щоб отримати один новий, і заздалегідь вивчайте умови.',
      h1: 'Контракти CS2',
    },
    de: {
      title: 'CS2 Trade Up Contracts — Skins kombinieren | SHOT',
      description:
        'Kombiniere mehrere CS2 Skins in einem SHOT Contract und erhalte einen neuen Gegenstand. Prüfe Anforderungen, Regeln und mögliche Ergebnisse vorab.',
      h1: 'CS2 Trade Up Contracts',
    },
    es: {
      title: 'Contratos de CS2 — Combinar skins | SHOT',
      description:
        'Usa los contratos de CS2 en SHOT: combina varios objetos del inventario para obtener uno nuevo y consulta antes los requisitos y posibles resultados.',
      h1: 'Contratos de CS2',
    },
    pl: {
      title: 'Kontrakty CS2 — Łączenie skinów | SHOT',
      description:
        'Korzystaj z kontraktów CS2 na SHOT: połącz kilka przedmiotów z ekwipunku, aby otrzymać jeden nowy, i wcześniej sprawdź wymagania oraz wyniki.',
      h1: 'Kontrakty CS2',
    },
  },
  '/case-battles/[battleId]': {
    ru: {
      title: 'Кейс-баттл CS2 — SHOT',
      description:
        'Кейс-баттл на SHOT: какие кейсы открыли участники, что выпало каждому и чем закончился баттл. Создай свой баттл или зайди в открытый.',
      h1: 'Кейс-баттл',
    },
    en: {
      title: 'CS2 case battle — SHOT',
      description:
        'A case battle on SHOT: which cases the players opened, what each of them got and how the battle ended. Create your own battle or join an open one.',
      h1: 'Case battle',
    },
    uz: {
      title: 'CS2 keys jangi — SHOT',
      description:
        'SHOTʼdagi keys jangi: ishtirokchilar qaysi keyslarni ochgani, har biriga nima tushgani va jang qanday tugagani. Oʻz jangingni yarat yoki ochiq jangga qoʻshil.',
      h1: 'Keys jangi',
    },
    fa: {
      title: 'نبرد کیس CS2 — SHOT',
      description:
        'یک نبرد کیس در SHOT: بازیکنان چه کیس‌هایی باز کردند، به هرکدام چه رسید و نبرد چطور تمام شد. نبرد خودت را بساز یا به یک نبرد باز بپیوند.',
      h1: 'نبرد کیس',
    },
    pt: {
      title: 'Batalha de caixas de CS2 — SHOT',
      description:
        'Uma batalha de caixas no SHOT: quais caixas os jogadores abriram, o que cada um recebeu e como a batalha terminou. Crie a sua ou entre em uma aberta.',
      h1: 'Batalha de caixas',
    },
    tr: {
      title: 'CS2 kasa savaşı — SHOT',
      description:
        "SHOT'ta bir kasa savaşı: oyuncuların hangi kasaları açtığı, her birine ne düştüğü ve savaşın nasıl bittiği. Kendi savaşını kur ya da açık bir savaşa katıl.",
      h1: 'Kasa savaşı',
    },
    uk: {
      title: 'Кейс-батл CS2 — SHOT',
      description:
        'Кейс-батл на SHOT: які кейси відкрили учасники, що випало кожному і чим закінчився батл. Створи свій батл або зайди у відкритий.',
      h1: 'Кейс-батл',
    },
    de: {
      title: 'CS2 Case Battle — SHOT',
      description:
        'Ein Case Battle auf SHOT: welche Cases die Spieler geöffnet haben, was jeder bekam und wie es endete. Erstelle dein eigenes Battle oder tritt einem offenen bei.',
      h1: 'Case Battle',
    },
    es: {
      title: 'Case Battle de CS2 — SHOT',
      description:
        'Un Case Battle en SHOT: qué cajas abrieron los participantes, qué consiguió cada uno y cómo terminó el battle. Crea el tuyo o únete a uno abierto.',
      h1: 'Case Battle',
    },
    pl: {
      title: 'Case Battle CS2 — SHOT',
      description:
        'Case Battle na SHOT: jakie skrzynki otworzyli uczestnicy, co wypadło każdemu i jak zakończył się battle. Utwórz własny battle albo dołącz do otwartego.',
      h1: 'Case Battle',
    },
  },
  '/shop': {
    ru: {
      title: 'Магазин скинов CS2 — SHOT',
      description:
        'Покупай скины CS2 в магазине SHOT за баланс: ножи, перчатки, винтовки, пистолеты, стикеры, агенты и брелоки. Подбирай по цене, редкости и износу.',
      h1: 'Магазин скинов CS2',
    },
    en: {
      title: 'CS2 skin shop — SHOT',
      description:
        'Buy CS2 skins in the SHOT shop with your balance: knives, gloves, rifles, pistols, stickers, agents and keychains. Filter by price, rarity and wear.',
      h1: 'CS2 skin shop',
    },
    uz: {
      title: 'CS2 skinlari doʻkoni — SHOT',
      description:
        'SHOT doʻkonida CS2 skinlarini balansga sotib ol: pichoqlar, qoʻlqoplar, miltiqlar, toʻpponchalar, stikerlar va agentlar. Narx, kamyoblik va holat boʻyicha tanla.',
      h1: 'CS2 skinlari doʻkoni',
    },
    fa: {
      title: 'فروشگاه اسکین CS2 — SHOT',
      description:
        'اسکین‌های CS2 را با موجودی از فروشگاه SHOT بخر: چاقو، دستکش، رایفل، پیستول، استیکر، ایجنت و آویز. بر اساس قیمت، کمیابی و فرسودگی انتخاب کن.',
      h1: 'فروشگاه اسکین CS2',
    },
    pt: {
      title: 'Loja de skins de CS2 — SHOT',
      description:
        'Compre skins de CS2 na loja do SHOT com o seu saldo: facas, luvas, rifles, pistolas, adesivos, agentes e chaveiros. Filtre por preço, raridade e desgaste.',
      h1: 'Loja de skins de CS2',
    },
    tr: {
      title: 'CS2 skin mağazası — SHOT',
      description:
        "SHOT mağazasından bakiyenle CS2 skinleri al: bıçaklar, eldivenler, tüfekler, tabancalar, çıkartmalar, ajanlar ve anahtarlıklar. Fiyata, nadirliğe ve aşınmaya göre seç.",
      h1: 'CS2 skin mağazası',
    },
    uk: {
      title: 'Магазин скінів CS2 — SHOT',
      description:
        'Купуй скіни CS2 у магазині SHOT за баланс: ножі, рукавиці, гвинтівки, пістолети, стікери, агентів і брелоки. Добирай за ціною, рідкісністю та зносом.',
      h1: 'Магазин скінів CS2',
    },
    de: {
      title: 'CS2 Skin-Shop — SHOT',
      description:
        'Kaufe CS2 Skins im SHOT-Shop mit deinem Guthaben: Messer, Handschuhe, Gewehre, Pistolen, Sticker, Agenten und Anhänger. Filtere nach Preis, Seltenheit und Zustand.',
      h1: 'CS2 Skin-Shop',
    },
    es: {
      title: 'Tienda de skins de CS2 — SHOT',
      description:
        'Compra skins de CS2 en la tienda de SHOT con tu saldo: cuchillos, guantes, rifles, pistolas, stickers, agentes y llaveros. Filtra por precio, rareza y desgaste.',
      h1: 'Tienda de skins de CS2',
    },
    pl: {
      title: 'Sklep ze skinami CS2 — SHOT',
      description:
        'Kupuj skiny CS2 w sklepie SHOT za saldo: noże, rękawice, karabiny, pistolety, naklejki, agentów i breloki. Filtruj według ceny, rzadkości i zużycia.',
      h1: 'Sklep ze skinami CS2',
    },
  },
  '/games': {
    ru: {
      title: 'Игры SHOT: Rush Mid, русская рулетка и Upgrade',
      description:
        'Все режимы SHOT в одном месте: Rush Mid, русская рулетка, Case Battles, контракты, Upgrade и магазин скинов. Выбирай, во что играть сегодня.',
      h1: 'Игры и режимы SHOT',
    },
    en: {
      title: 'SHOT games: Rush Mid, Russian Roulette and Upgrade',
      description:
        'Every SHOT mode in one place: Rush Mid, Russian Roulette, Case Battles, Contracts, Upgrade and the skin shop. Pick what you want to play today.',
      h1: 'SHOT games and modes',
    },
    uz: {
      title: 'SHOT oʻyinlari: Rush Mid, Rus ruletkasi va Upgrade',
      description:
        'SHOTʼning barcha rejimlari bir joyda: Rush Mid, Rus ruletkasi, Keys Janglar, Kontraktlar, Upgrade va skinlar doʻkoni. Bugun nima oʻynashni tanla.',
      h1: 'SHOT oʻyinlari va rejimlari',
    },
    fa: {
      title: 'بازی‌های SHOT: Rush Mid، رولت روسی و ارتقا',
      description:
        'همه حالت‌های SHOT در یک جا: Rush Mid، رولت روسی، نبرد کیس، قراردادها، ارتقا و فروشگاه اسکین. انتخاب کن امروز چه بازی کنی.',
      h1: 'بازی‌ها و حالت‌های SHOT',
    },
    pt: {
      title: 'Jogos do SHOT: Rush Mid, Roleta russa e Upgrade',
      description:
        'Todos os modos do SHOT em um só lugar: Rush Mid, Roleta russa, Batalhas de caixas, Contratos, Upgrade e a loja de skins. Escolha o que jogar hoje.',
      h1: 'Jogos e modos do SHOT',
    },
    tr: {
      title: 'SHOT oyunları: Rush Mid, Rus ruleti ve Upgrade',
      description:
        "SHOT'un tüm modları tek yerde: Rush Mid, Rus ruleti, Kasa savaşları, Kontratlar, Upgrade ve skin mağazası. Bugün ne oynayacağını seç.",
      h1: 'SHOT oyunları ve modları',
    },
    uk: {
      title: 'Ігри SHOT: Rush Mid, російська рулетка та Upgrade',
      description:
        'Усі режими SHOT в одному місці: Rush Mid, російська рулетка, Case Battles, контракти, Upgrade і магазин скінів. Обирай, у що грати сьогодні.',
      h1: 'Ігри та режими SHOT',
    },
    de: {
      title: 'SHOT Spiele: Rush Mid, Russisches Roulette und Upgrade',
      description:
        'Alle SHOT-Modi an einem Ort: Rush Mid, Russisches Roulette, Case Battles, Contracts, Upgrade und der Skin-Shop. Such dir aus, was du heute spielen willst.',
      h1: 'SHOT Spiele und Modi',
    },
    es: {
      title: 'Juegos de SHOT: Rush Mid, ruleta rusa y Upgrade',
      description:
        'Todos los modos de SHOT en un solo lugar: Rush Mid, ruleta rusa, Case Battles, contratos, Upgrade y la tienda de skins. Elige a qué jugar hoy.',
      h1: 'Juegos y modos de SHOT',
    },
    pl: {
      title: 'Gry SHOT: Rush Mid, rosyjska ruletka i Upgrade',
      description:
        'Wszystkie tryby SHOT w jednym miejscu: Rush Mid, rosyjska ruletka, Case Battles, kontrakty, Upgrade i sklep ze skinami. Wybierz, w co grasz dzisiaj.',
      h1: 'Gry i tryby SHOT',
    },
  },
  '/draws': {
    ru: {
      title: 'Победители розыгрышей SHOT',
      description:
        'Последние победители розыгрышей SHOT: кто получил награду, какой предмет ему достался и когда. Участвуй в розыгрышах и получай XP за участие.',
      h1: 'Победители розыгрышей',
    },
    en: {
      title: 'SHOT draw winners',
      description:
        'The latest SHOT draw winners: who got a reward, which item they received and when. Take part in the draws and earn XP just for joining in.',
      h1: 'Draw winners',
    },
    uz: {
      title: 'SHOT qura gʻoliblari',
      description:
        'SHOT quralarining soʻnggi gʻoliblari: kim mukofot olgani, unga qaysi predmet tushgani va qachon. Qurada qatnash va ishtirok uchun XP ol.',
      h1: 'Qura gʻoliblari',
    },
    fa: {
      title: 'برندگان قرعه‌کشی‌های SHOT',
      description:
        'آخرین برندگان قرعه‌کشی‌های SHOT: چه کسی جایزه گرفت، چه آیتمی به او رسید و کی. در قرعه‌کشی‌ها شرکت کن و برای شرکت XP بگیر.',
      h1: 'برندگان قرعه‌کشی',
    },
    pt: {
      title: 'Vencedores dos sorteios do SHOT',
      description:
        'Os últimos vencedores dos sorteios do SHOT: quem levou a recompensa, qual item recebeu e quando. Participe dos sorteios e ganhe XP só por participar.',
      h1: 'Vencedores dos sorteios',
    },
    tr: {
      title: 'SHOT çekiliş kazananları',
      description:
        'SHOT çekilişlerinin son kazananları: ödülü kim aldı, hangi eşyayı kazandı ve ne zaman. Çekilişlere katıl, sadece katıldığın için XP kazan.',
      h1: 'Çekiliş kazananları',
    },
    uk: {
      title: 'Переможці розіграшів SHOT',
      description:
        'Останні переможці розіграшів SHOT: хто отримав нагороду, який предмет йому дістався і коли. Бери участь у розіграшах і отримуй XP за участь.',
      h1: 'Переможці розіграшів',
    },
    de: {
      title: 'Gewinner der SHOT-Verlosungen',
      description:
        'Die neuesten Gewinner der SHOT-Verlosungen: wer eine Belohnung bekam, welches Item es war und wann. Nimm teil und sammle schon fürs Mitmachen XP.',
      h1: 'Gewinner der Verlosungen',
    },
    es: {
      title: 'Ganadores de los sorteos de SHOT',
      description:
        'Los últimos ganadores de los sorteos de SHOT: quién recibió una recompensa, qué objeto le tocó y cuándo. Participa en los sorteos y gana XP solo por apuntarte.',
      h1: 'Ganadores de los sorteos',
    },
    pl: {
      title: 'Zwycięzcy losowań SHOT',
      description:
        'Ostatni zwycięzcy losowań SHOT: kto dostał nagrodę, jaki przedmiot mu przypadł i kiedy. Bierz udział w losowaniach i zdobywaj XP już za samo uczestnictwo.',
      h1: 'Zwycięzcy losowań',
    },
  },
  '/rains': {
    ru: {
      title: 'Прошедшие раздачи SHOT',
      description:
        'История раздач SHOT: какие предметы разыгрывались, сколько игроков успело зайти и кто их забрал. Окно раздачи короткое — следи, чтобы не пропустить следующую.',
      h1: 'Прошедшие раздачи',
    },
    en: {
      title: 'Past SHOT giveaways',
      description:
        'The history of SHOT giveaways: which items were up for grabs, how many players made it in and who took them. The window is short, so watch for the next one.',
      h1: 'Past giveaways',
    },
    uz: {
      title: 'SHOTʼning oʻtgan ulashishlari',
      description:
        'SHOT ulashishlari tarixi: qaysi predmetlar ulashilgani, nechta oʻyinchi kirishga ulgurgani va ularni kim olgani. Ulashish oynasi qisqa — keyingisini oʻtkazib yuborma.',
      h1: 'Oʻtgan ulashishlar',
    },
    fa: {
      title: 'پخش‌های گذشته SHOT',
      description:
        'تاریخچه پخش‌های SHOT: چه آیتم‌هایی پخش شد، چند بازیکن به موقع وارد شدند و چه کسی آن‌ها را برد. فرصت ورود کوتاه است، پخش بعدی را از دست نده.',
      h1: 'پخش‌های گذشته',
    },
    pt: {
      title: 'Sorteios anteriores do SHOT',
      description:
        'Histórico dos sorteios relâmpago do SHOT: quais itens foram distribuídos, quantos jogadores entraram a tempo e quem os levou. A janela é curta, fique atento ao próximo.',
      h1: 'Sorteios anteriores',
    },
    tr: {
      title: 'SHOT geçmiş çekilişleri',
      description:
        "SHOT'taki anlık çekilişlerin geçmişi: hangi eşyalar dağıtıldı, kaç oyuncu zamanında girdi ve onları kim aldı. Giriş süresi kısa, bir sonrakini kaçırma.",
      h1: 'Geçmiş çekilişler',
    },
    uk: {
      title: 'Минулі роздачі SHOT',
      description:
        'Історія роздач SHOT: які предмети розігрувалися, скільки гравців устигло зайти і хто їх забрав. Вікно роздачі коротке — стеж, щоб не пропустити наступну.',
      h1: 'Минулі роздачі',
    },
    de: {
      title: 'Vergangene SHOT-Giveaways',
      description:
        'Die Geschichte der SHOT-Giveaways: welche Items verlost wurden, wie viele Spieler dabei waren und wer sie holte. Das Zeitfenster ist kurz – verpass das nächste nicht.',
      h1: 'Vergangene Giveaways',
    },
    es: {
      title: 'Repartos anteriores de SHOT',
      description:
        'El historial de repartos de SHOT: qué objetos se sortearon, cuántos jugadores llegaron y quién se los llevó. La ventana es corta, así que no te pierdas el próximo.',
      h1: 'Repartos anteriores',
    },
    pl: {
      title: 'Poprzednie rozdania SHOT',
      description:
        'Historia rozdań SHOT: jakie przedmioty były do wzięcia, ilu graczy zdążyło dołączyć i kto je odebrał. Okno rozdania jest krótkie — pilnuj, żeby nie przegapić następnego.',
      h1: 'Poprzednie rozdania',
    },
  },
  '/achievements': {
    ru: {
      title: 'Трофеи SHOT — задания и награды',
      description:
        'Все трофеи SHOT: за кейсы, Upgrade, контракты, Rush Mid, Case Battles и активность. Смотри условия получения, свой прогресс и награду за каждый трофей.',
      h1: 'Трофеи SHOT',
    },
    en: {
      title: 'SHOT trophies — challenges and rewards',
      description:
        'All SHOT trophies: for cases, Upgrade, Contracts, Rush Mid, Case Battles and activity. See how to earn each one, track your progress and check the reward.',
      h1: 'SHOT trophies',
    },
    uz: {
      title: 'SHOT kuboklari — vazifalar va mukofotlar',
      description:
        'SHOTʼning barcha kuboklari: keyslar, Upgrade, Kontraktlar, Rush Mid, Keys Janglar va faollik uchun. Har birini olish shartlari, progress va mukofotni koʻr.',
      h1: 'SHOT kuboklari',
    },
    fa: {
      title: 'جام‌های SHOT — چالش‌ها و جایزه‌ها',
      description:
        'همه جام‌های SHOT: برای کیس‌ها، ارتقا، قراردادها، Rush Mid، نبرد کیس و فعالیت. شرط گرفتن هرکدام، پیشرفتت و جایزه هر جام را ببین.',
      h1: 'جام‌های SHOT',
    },
    pt: {
      title: 'Troféus do SHOT — desafios e recompensas',
      description:
        'Todos os troféus do SHOT: por caixas, Upgrade, Contratos, Rush Mid, Batalhas de caixas e atividade. Veja como conquistar cada um, seu progresso e a recompensa.',
      h1: 'Troféus do SHOT',
    },
    tr: {
      title: 'SHOT kupaları — görevler ve ödüller',
      description:
        "SHOT'un tüm kupaları: kasalar, Upgrade, Kontratlar, Rush Mid, Kasa savaşları ve etkinlik için. Her birinin koşullarını, ilerlemeni ve ödülünü gör.",
      h1: 'SHOT kupaları',
    },
    uk: {
      title: 'Трофеї SHOT — завдання та нагороди',
      description:
        'Усі трофеї SHOT: за кейси, Upgrade, контракти, Rush Mid, Case Battles і активність. Дивись умови отримання, свій прогрес і нагороду за кожен трофей.',
      h1: 'Трофеї SHOT',
    },
    de: {
      title: 'SHOT Trophäen — Aufgaben und Belohnungen',
      description:
        'Alle SHOT-Trophäen: für Cases, Upgrade, Contracts, Rush Mid, Case Battles und Aktivität. Sieh dir Bedingungen, deinen Fortschritt und die Belohnung jeder Trophäe an.',
      h1: 'SHOT Trophäen',
    },
    es: {
      title: 'Trofeos de SHOT — retos y recompensas',
      description:
        'Todos los trofeos de SHOT: por cajas, Upgrade, contratos, Rush Mid, Case Battles y actividad. Consulta cómo conseguirlos, tu progreso y la recompensa de cada uno.',
      h1: 'Trofeos de SHOT',
    },
    pl: {
      title: 'Trofea SHOT — zadania i nagrody',
      description:
        'Wszystkie trofea SHOT: za skrzynki, Upgrade, kontrakty, Rush Mid, Case Battles i aktywność. Sprawdź warunki zdobycia, swój postęp i nagrodę za każde trofeum.',
      h1: 'Trofea SHOT',
    },
  },
  '/help/level': {
    ru: {
      title: 'Уровни и XP на SHOT — как прокачаться',
      description:
        'Как работают уровни SHOT: за что начисляется XP, сколько нужно до следующего уровня и какие бонусы открываются на ключевых уровнях.',
      h1: 'Уровни и XP на SHOT',
    },
    en: {
      title: 'SHOT levels and XP — how to level up',
      description:
        'How SHOT levels work: what earns you XP, how much you need for the next level and which bonuses unlock at the key levels along the way.',
      h1: 'SHOT levels and XP',
    },
    uz: {
      title: 'SHOTʼda darajalar va XP — qanday oshirish',
      description:
        'SHOT darajalari qanday ishlaydi: XP nima uchun beriladi, keyingi darajagacha qancha kerak va asosiy darajalarda qanday bonuslar ochiladi.',
      h1: 'SHOTʼda darajalar va XP',
    },
    fa: {
      title: 'سطح‌ها و XP در SHOT — چطور سطحت را بالا ببری',
      description:
        'سطح‌های SHOT چطور کار می‌کنند: برای چه کارهایی XP می‌گیری، تا سطح بعد چقدر لازم است و در سطح‌های کلیدی چه بونوس‌هایی باز می‌شود.',
      h1: 'سطح‌ها و XP در SHOT',
    },
    pt: {
      title: 'Níveis e XP no SHOT — como subir de nível',
      description:
        'Como funcionam os níveis do SHOT: o que dá XP, quanto falta para o próximo nível e quais bônus são liberados nos níveis principais.',
      h1: 'Níveis e XP no SHOT',
    },
    tr: {
      title: "SHOT'ta seviyeler ve XP — nasıl yükselirsin",
      description:
        "SHOT seviyeleri nasıl çalışır: XP'yi neyle kazanırsın, bir sonraki seviyeye ne kadar kaldı ve önemli seviyelerde hangi bonuslar açılır.",
      h1: "SHOT'ta seviyeler ve XP",
    },
    uk: {
      title: 'Рівні та XP на SHOT — як прокачатися',
      description:
        'Як працюють рівні SHOT: за що нараховується XP, скільки потрібно до наступного рівня і які бонуси відкриваються на ключових рівнях.',
      h1: 'Рівні та XP на SHOT',
    },
    de: {
      title: 'SHOT Level und XP — so steigst du auf',
      description:
        'So funktionieren die SHOT-Level: wofür es XP gibt, wie viel du fürs nächste Level brauchst und welche Boni auf den wichtigen Leveln freigeschaltet werden.',
      h1: 'Level und XP auf SHOT',
    },
    es: {
      title: 'Niveles y XP en SHOT — cómo subir de nivel',
      description:
        'Cómo funcionan los niveles de SHOT: qué da XP, cuánto necesitas para el siguiente nivel y qué bonos se desbloquean en los niveles clave.',
      h1: 'Niveles y XP en SHOT',
    },
    pl: {
      title: 'Poziomy i XP w SHOT — jak awansować',
      description:
        'Jak działają poziomy SHOT: za co dostajesz XP, ile potrzeba do kolejnego poziomu i jakie bonusy odblokowują się na kluczowych poziomach.',
      h1: 'Poziomy i XP w SHOT',
    },
  },
  '/help/recruiter': {
    ru: {
      title: 'Программа для блогеров SHOT',
      description:
        'Снимай обзоры SHOT для Instagram и TikTok и получай вознаграждение за просмотры. Рассказываем, что показать в видео, как подать заявку и как проходят выплаты.',
      h1: 'Программа для блогеров SHOT',
    },
    en: {
      title: 'SHOT Blogger Program',
      description:
        'Make SHOT review videos for Instagram and TikTok and get rewarded for views. Here is what to show in the video, how to apply and how payouts work.',
      h1: 'SHOT Blogger Program',
    },
    uz: {
      title: 'SHOT blogerlar dasturi',
      description:
        'Instagram va TikTok uchun SHOT haqida obzor suratga ol va koʻrishlar uchun mukofot ol. Videoda nimani koʻrsatish, qanday ariza berish va toʻlovlar haqida aytamiz.',
      h1: 'SHOT blogerlar dasturi',
    },
    fa: {
      title: 'برنامه بلاگرهای SHOT',
      description:
        'برای اینستاگرام و تیک‌تاک ویدیوی معرفی SHOT بساز و برای بازدیدها پاداش بگیر. می‌گوییم در ویدیو چه نشان بدهی، چطور درخواست بدهی و پرداخت‌ها چطور انجام می‌شود.',
      h1: 'برنامه بلاگرهای SHOT',
    },
    pt: {
      title: 'Programa para criadores do SHOT',
      description:
        'Grave vídeos sobre o SHOT para Instagram e TikTok e receba recompensa pelas visualizações. Veja o que mostrar no vídeo, como se inscrever e como são os pagamentos.',
      h1: 'Programa para criadores do SHOT',
    },
    tr: {
      title: 'SHOT içerik üreticisi programı',
      description:
        'Instagram ve TikTok için SHOT tanıtım videoları çek, izlenmeler için ödül al. Videoda ne göstereceğini, nasıl başvuracağını ve ödemelerin nasıl yapıldığını anlatıyoruz.',
      h1: 'SHOT içerik üreticisi programı',
    },
    uk: {
      title: 'Програма для блогерів SHOT',
      description:
        'Знімай огляди SHOT для Instagram і TikTok та отримуй винагороду за перегляди. Розповідаємо, що показати у відео, як подати заявку і як проходять виплати.',
      h1: 'Програма для блогерів SHOT',
    },
    de: {
      title: 'SHOT Blogger-Programm',
      description:
        'Dreh SHOT-Review-Videos für Instagram und TikTok und werde für Views belohnt. Hier steht, was du zeigst, wie du dich bewirbst und wie die Auszahlungen laufen.',
      h1: 'SHOT Blogger-Programm',
    },
    es: {
      title: 'Programa para bloggers de SHOT',
      description:
        'Graba reseñas de SHOT para Instagram y TikTok y recibe una recompensa por las visualizaciones. Qué mostrar en el vídeo, cómo solicitarlo y cómo son los pagos.',
      h1: 'Programa para bloggers de SHOT',
    },
    pl: {
      title: 'Program dla blogerów SHOT',
      description:
        'Nagrywaj recenzje SHOT na Instagram i TikToka i dostawaj nagrodę za wyświetlenia. Wyjaśniamy, co pokazać w filmie, jak złożyć zgłoszenie i jak wyglądają wypłaty.',
      h1: 'Program dla blogerów SHOT',
    },
  },
  '/how-it-works': {
    ru: {
      title: 'Как работает SHOT — баланс, кейсы и предметы',
      description:
        'Как устроен SHOT: пополняешь баланс, открываешь кейсы и получаешь цифровые предметы. Их можно оставить, продать за баланс или вывести в Steam, если это доступно.',
      h1: 'Как работает SHOT',
    },
    en: {
      title: 'How SHOT works — balance, cases and items',
      description:
        'How SHOT works: top up your balance, open cases and get digital items. Keep them, sell them for balance or withdraw them to Steam when that option is available.',
      h1: 'How SHOT works',
    },
    uz: {
      title: 'SHOT qanday ishlaydi — balans, keyslar va predmetlar',
      description:
        'SHOT qanday ishlaydi: balansni toʻldirasan, keyslarni ochasan va raqamli predmetlar olasan. Ularni saqlash, balansga sotish yoki imkon boʻlsa Steamʼga chiqarish mumkin.',
      h1: 'SHOT qanday ishlaydi',
    },
    fa: {
      title: 'SHOT چطور کار می‌کند — موجودی، کیس‌ها و آیتم‌ها',
      description:
        'SHOT چطور کار می‌کند: موجودی را شارژ می‌کنی، کیس باز می‌کنی و آیتم دیجیتال می‌گیری. می‌توانی نگهش داری، با موجودی بفروشی یا اگر ممکن بود به Steam برداشت کنی.',
      h1: 'SHOT چطور کار می‌کند',
    },
    pt: {
      title: 'Como o SHOT funciona — saldo, caixas e itens',
      description:
        'Como o SHOT funciona: você recarrega o saldo, abre caixas e recebe itens digitais. Pode guardá-los, vendê-los por saldo ou retirá-los para a Steam quando disponível.',
      h1: 'Como o SHOT funciona',
    },
    tr: {
      title: 'SHOT nasıl çalışır — bakiye, kasalar ve eşyalar',
      description:
        "SHOT nasıl çalışır: bakiyeni yüklersin, kasa açarsın ve dijital eşyalar alırsın. Onları saklayabilir, bakiye karşılığında satabilir ya da mümkünse Steam'e çekebilirsin.",
      h1: 'SHOT nasıl çalışır',
    },
    uk: {
      title: 'Як працює SHOT — баланс, кейси та предмети',
      description:
        'Як влаштований SHOT: поповнюєш баланс, відкриваєш кейси та отримуєш цифрові предмети. Їх можна залишити, продати за баланс або вивести в Steam, якщо це доступно.',
      h1: 'Як працює SHOT',
    },
    de: {
      title: 'So funktioniert SHOT — Guthaben, Cases und Items',
      description:
        'So funktioniert SHOT: Lade Guthaben auf, öffne Cases und erhalte digitale Items. Behalte sie, verkaufe sie für Guthaben oder lass sie nach Steam auszahlen, wenn möglich.',
      h1: 'So funktioniert SHOT',
    },
    es: {
      title: 'Cómo funciona SHOT — saldo, cajas y objetos',
      description:
        'Cómo funciona SHOT: recargas saldo, abres cajas y recibes objetos digitales. Conserva los objetos, véndelos por saldo o retíralos a Steam cuando sea posible.',
      h1: 'Cómo funciona SHOT',
    },
    pl: {
      title: 'Jak działa SHOT — saldo, skrzynki i przedmioty',
      description:
        'Jak działa SHOT: doładowujesz saldo, otwierasz skrzynki i dostajesz cyfrowe przedmioty. Zatrzymaj je, sprzedaj za saldo albo wypłać na Steam, gdy to możliwe.',
      h1: 'Jak działa SHOT',
    },
  },
  '/support': {
    ru: {
      title: 'Поддержка SHOT — как с нами связаться',
      description:
        'Напиши в поддержку SHOT на почту или в Telegram, если что-то пошло не так с балансом, кейсом или выводом предмета. Здесь же часы работы и сроки ответа.',
      h1: 'Поддержка SHOT',
    },
    en: {
      title: 'SHOT support — how to reach us',
      description:
        'Contact SHOT support by email or Telegram if something went wrong with your balance, a case or an item withdrawal. Working hours and response times are here too.',
      h1: 'SHOT support',
    },
    uz: {
      title: 'SHOT qoʻllab-quvvatlash — biz bilan aloqa',
      description:
        'Balans, keys yoki predmetni chiqarishda muammo boʻlsa, SHOT qoʻllab-quvvatlash xizmatiga pochta yoki Telegram orqali yoz. Ish vaqti va javob muddati ham shu yerda.',
      h1: 'SHOT qoʻllab-quvvatlash',
    },
    fa: {
      title: 'پشتیبانی SHOT — راه‌های تماس',
      description:
        'اگر در موجودی، کیس یا برداشت آیتم مشکلی پیش آمد، از طریق ایمیل یا تلگرام به پشتیبانی SHOT پیام بده. ساعت کاری و زمان پاسخ هم اینجاست.',
      h1: 'پشتیبانی SHOT',
    },
    pt: {
      title: 'Suporte do SHOT — como falar com a gente',
      description:
        'Fale com o suporte do SHOT por e-mail ou Telegram se algo der errado com o seu saldo, uma caixa ou a retirada de um item. Veja também o horário e o prazo de resposta.',
      h1: 'Suporte do SHOT',
    },
    tr: {
      title: 'SHOT destek — bize nasıl ulaşırsın',
      description:
        "Bakiye, kasa ya da eşya çekme işleminde bir sorun olursa SHOT desteğine e-posta veya Telegram'dan yaz. Çalışma saatleri ve yanıt süreleri de burada.",
      h1: 'SHOT destek',
    },
    uk: {
      title: 'Підтримка SHOT — як із нами зв’язатися',
      description:
        'Напиши в підтримку SHOT на пошту або в Telegram, якщо щось пішло не так із балансом, кейсом чи виведенням предмета. Тут же години роботи та строки відповіді.',
      h1: 'Підтримка SHOT',
    },
    de: {
      title: 'SHOT Support — so erreichst du uns',
      description:
        'Schreib dem SHOT-Support per E-Mail oder Telegram, wenn bei Guthaben, Case oder Item-Auszahlung etwas schiefging. Hier stehen auch Arbeits- und Antwortzeiten.',
      h1: 'SHOT Support',
    },
    es: {
      title: 'Soporte de SHOT — cómo contactarnos',
      description:
        'Escribe al soporte de SHOT por correo o Telegram si algo falló con tu saldo, una caja o la retirada de un objeto. Aquí también tienes horarios y plazos de respuesta.',
      h1: 'Soporte de SHOT',
    },
    pl: {
      title: 'Wsparcie SHOT — jak się z nami skontaktować',
      description:
        'Napisz do wsparcia SHOT na e-mail lub w Telegramie, jeśli coś poszło nie tak z saldem, skrzynką albo wypłatą przedmiotu. Są tu też godziny pracy i czas odpowiedzi.',
      h1: 'Wsparcie SHOT',
    },
  },
  '/contacts': {
    ru: {
      title: 'Контакты SHOT — реквизиты и связь',
      description:
        'Реквизиты и контакты SHOT: ИНН, юридический адрес, телефон и электронная почта. Вопросы по аккаунту, балансу и предметам быстрее решит поддержка.',
      h1: 'Контакты SHOT',
    },
    en: {
      title: 'SHOT contacts and company details',
      description:
        'SHOT contacts and company details: tax ID, legal address, phone and email. For questions about your account, balance or items, support will answer faster.',
      h1: 'SHOT contacts',
    },
    uz: {
      title: 'SHOT kontaktlari va rekvizitlari',
      description:
        'SHOT rekvizitlari: STIR, yuridik manzil, telefon va elektron pochta. Akkaunt, balans yoki predmetlar boʻyicha savollarga qoʻllab-quvvatlash tezroq javob beradi.',
      h1: 'SHOT kontaktlari',
    },
    fa: {
      title: 'تماس با SHOT و مشخصات کسب‌وکار',
      description:
        'اطلاعات تماس و مشخصات SHOT: شناسه مالیاتی، نشانی حقوقی، تلفن و ایمیل. برای سؤال درباره حساب، موجودی یا آیتم‌ها، پشتیبانی سریع‌تر پاسخ می‌دهد.',
      h1: 'تماس با SHOT',
    },
    pt: {
      title: 'Contatos e dados do SHOT',
      description:
        'Contatos e dados do SHOT: ID fiscal, endereço legal, telefone e e-mail. Para dúvidas sobre conta, saldo ou itens, o suporte responde mais rápido.',
      h1: 'Contatos do SHOT',
    },
    tr: {
      title: 'SHOT iletişim ve şirket bilgileri',
      description:
        'SHOT iletişim ve şirket bilgileri: vergi numarası, yasal adres, telefon ve e-posta. Hesap, bakiye ya da eşyalarla ilgili sorularda destek daha hızlı yanıt verir.',
      h1: 'SHOT iletişim',
    },
    uk: {
      title: 'Контакти SHOT — реквізити та зв’язок',
      description:
        'Реквізити та контакти SHOT: податковий номер, юридична адреса, телефон і електронна пошта. Питання щодо акаунта, балансу та предметів швидше вирішить підтримка.',
      h1: 'Контакти SHOT',
    },
    de: {
      title: 'SHOT Kontakt und Firmendaten',
      description:
        'Kontakt und Firmendaten von SHOT: Steuernummer, Firmenanschrift, Telefon und E-Mail. Bei Fragen zu Konto, Guthaben oder Items hilft dir der Support schneller weiter.',
      h1: 'SHOT Kontakt',
    },
    es: {
      title: 'Contacto de SHOT y datos de la empresa',
      description:
        'Contacto y datos de la empresa SHOT: identificación fiscal, domicilio legal, teléfono y correo. Para dudas sobre tu cuenta, saldo u objetos, el soporte responde antes.',
      h1: 'Contacto de SHOT',
    },
    pl: {
      title: 'Kontakt z SHOT i dane firmy',
      description:
        'Kontakt i dane firmy SHOT: numer podatkowy, adres siedziby, telefon i e-mail. W sprawach konta, salda i przedmiotów szybciej pomoże wsparcie.',
      h1: 'Kontakt z SHOT',
    },
  },
  '/refund-terms': {
    ru: {
      title: 'Условия возврата средств — SHOT',
      description:
        'Условия возврата SHOT: когда можно вернуть деньги за пополнение баланса, а когда нет, как отправить запрос в поддержку и сколько длится рассмотрение.',
      h1: 'Условия возврата средств',
    },
    en: {
      title: 'Refund terms — SHOT',
      description:
        'SHOT refund terms: when a balance top-up can be refunded and when it cannot, how to send a request to support and how long the review takes.',
      h1: 'Refund terms',
    },
    uz: {
      title: 'Qaytarish shartlari — SHOT',
      description:
        'SHOT qaytarish shartlari: balansni toʻldirish uchun pul qachon qaytariladi va qachon qaytarilmaydi, soʻrovni qanday yuborish va koʻrib chiqish qancha davom etishi.',
      h1: 'Qaytarish shartlari',
    },
    fa: {
      title: 'شرایط بازگشت وجه — SHOT',
      description:
        'شرایط بازگشت وجه در SHOT: چه زمانی مبلغ شارژ موجودی برگردانده می‌شود و چه زمانی نه، چطور درخواست بدهی و بررسی آن چقدر طول می‌کشد.',
      h1: 'شرایط بازگشت وجه',
    },
    pt: {
      title: 'Condições de reembolso — SHOT',
      description:
        'Condições de reembolso do SHOT: quando uma recarga de saldo pode ser devolvida e quando não, como enviar o pedido ao suporte e quanto tempo leva a análise.',
      h1: 'Condições de reembolso',
    },
    tr: {
      title: 'İade koşulları — SHOT',
      description:
        'SHOT iade koşulları: bakiye yüklemesi hangi durumlarda iade edilir, hangilerinde edilmez, talep nasıl gönderilir ve inceleme ne kadar sürer.',
      h1: 'İade koşulları',
    },
    uk: {
      title: 'Умови повернення коштів — SHOT',
      description:
        'Умови повернення SHOT: коли можна повернути гроші за поповнення балансу, а коли ні, як надіслати запит у підтримку і скільки триває розгляд.',
      h1: 'Умови повернення коштів',
    },
    de: {
      title: 'Rückerstattungsbedingungen — SHOT',
      description:
        'Rückerstattung bei SHOT: wann eine Aufladung erstattet werden kann und wann nicht, wie du eine Anfrage an den Support schickst und wie lange die Prüfung dauert.',
      h1: 'Rückerstattungsbedingungen',
    },
    es: {
      title: 'Condiciones de reembolso — SHOT',
      description:
        'Condiciones de reembolso de SHOT: cuándo se puede devolver una recarga de saldo y cuándo no, cómo enviar una solicitud al soporte y cuánto dura la revisión.',
      h1: 'Condiciones de reembolso',
    },
    pl: {
      title: 'Warunki zwrotu środków — SHOT',
      description:
        'Warunki zwrotu SHOT: kiedy można odzyskać pieniądze za doładowanie salda, a kiedy nie, jak wysłać prośbę do wsparcia i ile trwa rozpatrzenie.',
      h1: 'Warunki zwrotu środków',
    },
  },
  '/digital-content': {
    ru: {
      title: 'Получение цифрового контента — SHOT',
      description:
        'Как SHOT выдаёт цифровой контент: предметы приходят внутри платформы, часть из них можно вывести на свой аккаунт Steam, передача идёт автоматически.',
      h1: 'Получение цифрового контента',
    },
    en: {
      title: 'Receiving digital content — SHOT',
      description:
        'How SHOT delivers digital content: items arrive inside the platform, some of them can be withdrawn to your own Steam account, and transfers run automatically.',
      h1: 'Receiving digital content',
    },
    uz: {
      title: 'Raqamli kontent olish — SHOT',
      description:
        'SHOT raqamli kontentni qanday beradi: predmetlar platforma ichida beriladi, ayrimlarini oʻz Steam akkauntingga chiqarish mumkin, oʻtkazma avtomatik amalga oshadi.',
      h1: 'Raqamli kontent olish',
    },
    fa: {
      title: 'دریافت محتوای دیجیتال — SHOT',
      description:
        'SHOT محتوای دیجیتال را چطور تحویل می‌دهد: آیتم‌ها داخل پلتفرم داده می‌شوند، بعضی را می‌توانی به حساب Steam خودت برداشت کنی و انتقال خودکار است.',
      h1: 'دریافت محتوای دیجیتال',
    },
    pt: {
      title: 'Recebimento de conteúdo digital — SHOT',
      description:
        'Como o SHOT entrega conteúdo digital: os itens chegam dentro da plataforma, alguns podem ser retirados para a sua conta Steam e a transferência é automática.',
      h1: 'Recebimento de conteúdo digital',
    },
    tr: {
      title: 'Dijital içerik alma — SHOT',
      description:
        'SHOT dijital içeriği nasıl teslim eder: eşyalar platform içinde verilir, bazılarını kendi Steam hesabına çekebilirsin ve aktarım otomatik yapılır.',
      h1: 'Dijital içerik alma',
    },
    uk: {
      title: 'Отримання цифрового контенту — SHOT',
      description:
        'Як SHOT видає цифровий контент: предмети надходять усередині платформи, частину з них можна вивести на свій акаунт Steam, передача йде автоматично.',
      h1: 'Отримання цифрового контенту',
    },
    de: {
      title: 'Erhalt digitaler Inhalte — SHOT',
      description:
        'So liefert SHOT digitale Inhalte: Items kommen direkt in der Plattform an, manche kannst du auf dein Steam-Konto auszahlen lassen. Die Übertragung läuft automatisch.',
      h1: 'Erhalt digitaler Inhalte',
    },
    es: {
      title: 'Recepción de contenido digital — SHOT',
      description:
        'Cómo entrega SHOT el contenido digital: los objetos llegan dentro de la plataforma, algunos se pueden retirar a tu cuenta de Steam y la transferencia es automática.',
      h1: 'Recepción de contenido digital',
    },
    pl: {
      title: 'Otrzymanie treści cyfrowych — SHOT',
      description:
        'Jak SHOT dostarcza treści cyfrowe: przedmioty trafiają na platformę, część z nich można wypłacić na własne konto Steam, a przekazanie odbywa się automatycznie.',
      h1: 'Otrzymanie treści cyfrowych',
    },
  },
  '/free-skins': {
    ru: {
      title: 'Бесплатный скин CS2 на SHOT — условия и как получить',
      description:
        'Как получить бесплатный скин CS2 на SHOT: стартовые монеты за регистрацию, открытие кейса без пополнения, условия продажи и вывода скина в Steam.',
      h1: 'Бесплатный скин CS2 на SHOT',
    },
    en: {
      title: 'Free CS2 skin on SHOT — terms and how to get it',
      description:
        'How to get a free CS2 skin on SHOT: starter coins at sign-up, a case opened without a top-up, and the exact terms for selling or withdrawing the skin to Steam.',
      h1: 'Free CS2 skin on SHOT',
    },
    uz: {
      title: 'SHOTʼda CS2 uchun bepul skin — shartlar va olish yoʻli',
      description:
        'SHOTʼda CS2 uchun bepul skinni qanday olish mumkin: roʻyxatdan oʻtganda boshlangʻich tangalar, balansni toʻldirmasdan keys ochish, sotish va Steamʼga chiqarish shartlari.',
      h1: 'SHOTʼda CS2 uchun bepul skin',
    },
    fa: {
      title: 'اسکین رایگان CS2 در SHOT — شرایط و روش دریافت',
      description:
        'چطور در SHOT اسکین رایگان CS2 بگیری: سکه‌های شروع هنگام ثبت‌نام، باز کردن کیس بدون شارژ موجودی و شرایط فروش اسکین یا برداشت آن به Steam.',
      h1: 'اسکین رایگان CS2 در SHOT',
    },
    pt: {
      title: 'Skin de CS2 grátis no SHOT — regras e como pegar',
      description:
        'Como pegar uma skin de CS2 grátis no SHOT: moedas iniciais no cadastro, caixa aberta sem depósito e as regras para vender a skin ou retirá-la para a Steam.',
      h1: 'Skin de CS2 grátis no SHOT',
    },
    tr: {
      title: "SHOT'ta bedava CS2 skin — koşullar ve nasıl alınır",
      description:
        "SHOT'ta bedava CS2 skin nasıl alınır: kayıtta başlangıç coin'leri, bakiye yüklemeden kasa açma ve skini satma ya da Steam'e çekme koşulları.",
      h1: "SHOT'ta bedava CS2 skin",
    },
    uk: {
      title: 'Безкоштовний скін CS2 на SHOT — умови і як отримати',
      description:
        'Як отримати безкоштовний скін CS2 на SHOT: стартові монети за реєстрацію, відкриття кейса без поповнення, умови продажу та виведення скіна до Steam.',
      h1: 'Безкоштовний скін CS2 на SHOT',
    },
    de: {
      title: 'Gratis-CS2-Skin auf SHOT — Bedingungen und Erhalt',
      description:
        'So holst du dir einen Gratis-CS2-Skin auf SHOT: Startmünzen zur Registrierung, ein Case ohne Aufladung und die Bedingungen für Verkauf und Auszahlung.',
      h1: 'Gratis-CS2-Skin auf SHOT',
    },
    es: {
      title: 'Skin de CS2 gratis en SHOT: condiciones y cómo conseguirlo',
      description:
        'Cómo conseguir un skin de CS2 gratis en SHOT: monedas de inicio al registrarte, una caja abierta sin recargar y las condiciones para vender el skin o retirarlo a Steam.',
      h1: 'Skin de CS2 gratis en SHOT',
    },
    pl: {
      title: 'Darmowy skin CS2 na SHOT — warunki i jak go zdobyć',
      description:
        'Jak zdobyć darmowy skin CS2 na SHOT: monety startowe za rejestrację, otwarcie skrzynki bez doładowania oraz warunki sprzedaży skina i wypłaty na Steam.',
      h1: 'Darmowy skin CS2 na SHOT',
    },
  },
};

export const routeIndexedLanguages = (path: string): readonly Language[] | undefined => {
  const policy = routePolicy(path);
  return policy.sitemap ? policy.availableLocales : undefined;
};

const PATTERNS = Object.keys(ROUTE_SEO);

const isParam = (segment: string) => segment.startsWith('[') && segment.endsWith(']');

// WHY: параметр в шаблоне — только id, иначе /case-battles/create и /case-battles/history получили бы тексты баттла
const matchesPattern = (pattern: string, path: string): boolean => {
  const expected = pattern.split('/');
  const actual = path.split('/');
  return (
    expected.length === actual.length &&
    expected.every((segment, i) => (isParam(segment) ? isValidUuid(actual[i]) : segment === actual[i]))
  );
};

export function findRouteSeo(path: string): RouteSeo | undefined {
  const pattern = PATTERNS.find((candidate) => matchesPattern(candidate, path));
  return pattern ? ROUTE_SEO[pattern] : undefined;
}

export const STATIC_SEO_PATHS: readonly string[] = PATTERNS.filter((pattern) => !pattern.split('/').some(isParam));
